import { ActionTypes } from "../contants/action-type.js";

import {
    getInvoices,
    getSelectedItem,
    
} from '../../services/InvoiceService.js';

export function getInvoiceAction() {
    return (dispatch, getState) => {
        getInvoices()
            .then((response) => {
                dispatch(listItems(response.data));
            });
    };
}

export function getSelectedInvoiceAction(id) {
    return (dispatch, getState) => {
        getSelectedItem(id).then((response) => {
            dispatch(selectedItem(response.data));
        });
    };
}


export const listItems = (invoices) => {
    return {
        type: ActionTypes.LIST_INVOICE,
        payload: invoices
    }
}


export const selectedItem = (invoice) => {
    return {
        type: ActionTypes.INVOICE_ORDER,
        payload: invoice
    }
}
